export default "__VITE_ASSET__396e1ce7__"